<template>
  <div class="modal-bg">
    <div class="modal-content">
      <h3>
        {{ isUpdateMode ?  $t('general.edit_question') : $t('general.add_question')  }}
        <span v-if="localData.time_in_video" class="time-info">
           ({{  (localData.time_in_video) }})
        </span>
      </h3>
      
      <!-- Message Notifications -->
      <MessageNotification :message="alertMessage" @remove="removeAlertMessage"/>

      <label class="modal-label"> {{ $t('general.question_text') }}</label>
      <textarea
          v-model="localData.text"
          class="input question-text"
          :placeholder="$t('general.add_question')"
      />

      <div v-for="(opt, oidx) in localData.options" :key="oidx" class="option-row">
        <input
            v-model="opt.name"
            class="input option-input"
            :placeholder="$t('general.add_option')"
        />
        <toggle-switch 
          :value="opt.is_correct" 
          :title="opt.is_correct ? $t('general.correct') : $t('general.wrong')"
          @input="handleCorrectAnswerChange(oidx, $event)"
        />
        <button
          v-if="localData.options.length>2"
          type="button"
          class="remove-option-btn"
          @click.prevent="removeOption(oidx)"
        >X</button>
      </div>
      <button type="button" class="add-option-btn" @click.prevent="addOption">+ {{$t('general.add_option')}}</button>

      <!-- eğer souya yanlış cevap veririse, gideceği konum -->
      <div class="backtime-toggle-row">
        <toggle-switch v-model="showBackTime" :title="$t('general.back_time_header')"/>
      </div>
      <div v-if="showBackTime" class="backtime-fields">
        <label class="backtime-label"> {{$t('general.back_time_info')}} </label>
        <div class="backtime-inputs">
          <input v-model.number="backHour" class="input backtime-input" max="23" min="0" placeholder="hh" type="number"
                 @input="updateBackTime"/>
          <span>:</span>
          <input v-model.number="backMinute" class="input backtime-input" max="59" min="0" placeholder="mm"
                 type="number" @input="updateBackTime"/>
          <span>:</span>
          <input v-model.number="backSecond" class="input backtime-input" max="59" min="0" placeholder="ss"
                 type="number" @input="updateBackTime"/>
        </div>
      </div>

      <div class="feedback-toggle-row">
        <toggle-switch v-model="showFeedback" :title="$t('general.exam_add_feedback')"/>
      </div>

      <div v-if="showFeedback" class="feedback-fields">
        <div>
          <label class="feedback-title"> {{$t('general.if_true_answer')}} </label>
          <textarea
              v-model="localData.correct_feedback"
              class="input textarea"
              :placeholder="$t('general.write_your_notification')"
          />
        </div>
        <div>
          <label class="feedback-title"> {{$t('general.if_false_answer')}} </label>
          <textarea
              v-model="localData.incorrect_feedback"
              class="input textarea"
              :placeholder="$t('general.write_your_notification')"
          />
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="cancel-btn" @click.prevent="closeModal"> {{$t('general.cancel')}} </button>
        <button type="button" class="save-btn" @click.prevent="save">{{ isUpdateMode ? $t('general.update'):$t('general.save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from '@/view/components/toggle/toggle-switch/toggle-switch.vue';
import MessageNotification from '@/view/components/notification/AlertMessage.vue';

export default {
  name: 'QuestionModalDefault',
  components: {
    ToggleSwitch,
    MessageNotification
  },
  computed: {
    selectedItemData() {
      return this.$store.getters.selectedItemData;
    },
    isUpdateMode() {
      // selectedItemData'da isUpdateMode varsa güncelleme modu
      return this.selectedItemData && this.selectedItemData.isUpdateMode;
    }
  },
  data() {
    return {
      localData: {
        id: null,
        text: '',
        type: 1,
        time_in_video: '',
        back_time: '',
        time: 0,
        options: [
          { name: '', is_correct: false },
          { name: '', is_correct: false },
          { name: '', is_correct: false },
          { name: '', is_correct: false },
        ],
        correct_feedback: '',
        incorrect_feedback: ''
      },
      showFeedback: false,
      showBackTime: false,
      backHour: 0,
      backMinute: 0,
      backSecond: 0,
      alertMessage: null
    };
  },
  methods: {
    addOption() {
      this.localData.options.push({ name: '', is_correct: false });
    },
    removeOption(idx) {
      // Minimum 2 şık olmalı
      if (this.localData.options.length > 2) {
        this.localData.options.splice(idx, 1);
      }
    },
    handleCorrectAnswerChange(selectedIndex, newValue) {
      // Yeni değeri seçilen seçeneğe ata
      this.localData.options[selectedIndex].is_correct = newValue;
      
      // Eğer yeni değer true ise, diğer tüm seçenekleri false yap
      if (newValue === true) {
        this.localData.options.forEach((option, index) => {
          if (index !== selectedIndex) {
            option.is_correct = false;
          }
        });
      }
    },
    updateBackTime() {
      // Format: hh:mm:ss - BE'de time tutulma şekli
      const hh = String(this.backHour).padStart(2, '0');
      const mm = String(this.backMinute).padStart(2, '0');
      const ss = String(this.backSecond).padStart(2, '0');
      this.localData.back_time = `${hh}:${mm}:${ss}`;
    },
    closeModal() {
      this.$store.dispatch('closeModal');
    },
    save() {
      const isAllValid=this.checkValidation()

      if(!isAllValid){
        return
      }

      // Store'dan gelen veriyi kullan
      if (this.selectedItemData) {
        this.localData.type = this.selectedItemData.typeId || 1;
        this.localData.time_in_video = this.selectedItemData.time_in_video;
        this.localData.time = this.selectedItemData.time || 0;
      }
      
      if (!this.showBackTime) {
        this.localData.back_time = '';
      } else {
        this.updateBackTime();
      }
      
      // Eğer showFeedback kapatılırsa, içteki verileri temizle
      if (!this.showFeedback) {
        this.localData.correct_feedback = '';
        this.localData.incorrect_feedback = '';
      }
      
      if (this.isUpdateMode) {
        // Güncelleme modu - mevcut marker'ı güncelle
        this.$store.dispatch('updateMarker', {
          markerId: this.localData.id,
          updatedMarker: this.localData
        });
      } else {
        // Ekleme modu - yeni marker ekle
        this.$store.dispatch('addMarker', this.localData);
      }
      
      this.closeModal();
    },
    checkValidation(){
      this.alertMessage = null;
      
      if (!this.localData.text || this.localData.text.trim() === '') {
        this.alertMessage = {
          type: 'error',
          text: this.$t('validation.question_cannot_be_empty')
        };
        return false;
      }

      // Şıkların boş olup olmadığı kontrolü
      const emptyOptions = this.localData.options.filter(opt => !opt.name || opt.name.trim() === '');
      if (emptyOptions.length > 0) {
        this.alertMessage = {
          type: 'error',
          text: this.$t('general.all_options_must_be_filled')
        };
        return false;
      }

      // Tam olarak bir doğru cevap seçilmiş mi kontrolü
      const correctOptions = this.localData.options.filter(opt => opt.is_correct);
      if (correctOptions.length === 0) {
        this.alertMessage = {
          type: 'error',
          text: this.$t('general.one_correct_answer_must_be_selected')
        };
        return false;
      }
      
      if (correctOptions.length > 1) {
        this.alertMessage = {
          type: 'error',
          text: this.$t('general.only_one_correct_answer_must_be_selected')
        };
        return false;
      }

      return true;
    },
    removeAlertMessage() {
      this.alertMessage = null;
    }
  },
  mounted() {
    // Store'dan gelen veriyi kullan
    if (this.selectedItemData) {

      if (this.isUpdateMode) {
        // Güncelleme modu - mevcut veriyi yükle
        this.localData = { ...this.selectedItemData };


        // Feedback varsa göster
        this.showFeedback = !!(this.localData.is_feedback || this.localData.correct_feedback || this.localData.incorrect_feedback);
        
        // Back time varsa parse et
        if (this.localData.back_time) {
          const parts = this.localData.back_time.split(':');
          if (parts.length === 3) {
            this.backHour = parseInt(parts[0]) || 0;
            this.backMinute = parseInt(parts[1]) || 0;
            this.backSecond = parseInt(parts[2]) || 0;
            this.showBackTime = true;
          }
        }

      } else {
        // Yeni marker ekleme modu - yeni ID oluştur
        this.localData.id = Date.now() + Math.random();
        this.localData.type = this.selectedItemData.typeId || 1;
        this.localData.time_in_video = this.selectedItemData.time_in_video;
        this.localData.time = this.selectedItemData.time || 0;
        
        this.localData.back_time = '';
        this.backHour = 0;
        this.backMinute = 0;
        this.backSecond = 0;
      }
    }
  }
};
</script>

<style scoped>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 32px 32px 24px 32px;
  min-width: 420px;
  max-width: 800px;
  max-height: 80vh; /* Maximum height of 80% of viewport height */
  overflow-y: auto; /* Enable vertical scrolling */
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
  text-align: left;
  position: relative;
}

.time-info {
  font-size: 14px;
  color: #23ade5;
  font-weight: 500;
  margin-left: 8px;
}

/* Custom scrollbar styling for the modal */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 4px;
  margin: 4px 0;
}

.modal-content::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
}

.input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d0d7e2;
  margin-bottom: 12px;
  font-size: 15px;
  background: #f8fafd;
  resize: none;
}

/* Question text input - taller */
.input.question-text {
  min-height: 60px;
  height: 72px; /* 3 lines default (24px per line) */
  padding: 16px 12px;
  font-size: 16px;
  line-height: 1.5;
  resize: vertical; /* Allow vertical resizing only */
}

/* Option inputs - shorter */
.option-input {
  min-height: 40px;
  height: 40px; /* 1 line default */
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.4;
}

.textarea {
  min-height: 48px;
  max-height: 120px;
}

.option-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.correct-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
}

.remove-option-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #d33;
}

.add-option-btn {
  background: #eaf6fb;
  color: #23ade5;
  border: none;
  border-radius: 8px;
  padding: 9px 0;
  font-size: 16px;
  width: 100%;
  margin-bottom: 14px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.15s;
}

.add-option-btn:hover {
  background: #d6f0fa;
}

.backtime-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 10px 0;
}

.backtime-fields {
  margin-bottom: 12px;
}

.backtime-label {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
  display: block;
}

.backtime-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.backtime-input {
  width: 48px;
  padding: 8px 6px;
  border-radius: 6px;
  border: 1px solid #d0d7e2;
  font-size: 15px;
  text-align: center;
}

.feedback-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 10px 0;
}

.feedback-fields {
  display: flex;
  gap: 16px;
  margin-bottom: 10px;
}

.feedback-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
  display: block;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 18px;
}

.save-btn {
  background: #23ade5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cancel-btn {
  background: #f0f4f8;
  color: #444;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
</style> 